(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(function() {
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function setup() {
    // Only targets accordion toggles (About Us / Column 1 is excluded
    // since it no longer has a [data-footer-accordion-toggle] button).
    var toggles = document.querySelectorAll('[data-footer-accordion-toggle]');

    toggles.forEach(function(toggle) {
      var panel = toggle.nextElementSibling;
      if (!panel) return;

      if (mobileQuery.matches) {
        // Collapsed by default on mobile
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        panel.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  function toggleAccordion(toggle) {
    if (!mobileQuery.matches) return;
    var panel = toggle.nextElementSibling;
    if (!panel) return;
    var isOpen = panel.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  document.querySelectorAll('[data-footer-accordion-toggle]').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      toggleAccordion(toggle);
    });
  });

  setup();

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', setup);
  } else if (mobileQuery.addListener) {
    // Safari < 14 fallback
    mobileQuery.addListener(setup);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
